module.exports = __webpack_public_path__ + "img/TradingView-icon15_en.65681275.svg";